import { beautyProfilerProductRepository } from "../repository/ProductRepository";
import { BeautyProfilerAllureId } from "../types/BeautyProfilerAllure";
import { ProfilerProductId } from "../types/ProfilerProduct";
import { getRandomIdWithMaxScore } from "./productUtils";


export const getMainAllureId = (
  allureScores: Map<BeautyProfilerAllureId, number>
): BeautyProfilerAllureId => {
  return getRandomIdWithMaxScore(allureScores);
};

export const getMainFeticheFragranceId = (
  productScores: Map<ProfilerProductId, number>
): ProfilerProductId => {
  const feticheProducts = beautyProfilerProductRepository
    .getAllProducts()
    .filter((product) => product.type === "fetiche");
  const boostedFeticheProducts = feticheProducts.filter(
    (product) => product.boost > 0
  );
  const totalBoost = boostedFeticheProducts.reduce(
    (acc, product) => acc + product.boost,
    0
  );
  const randomBoost = Math.floor(Math.random() * 100);

  let currentBoost = 0;
  let currentProductIndex = 0;

  while (
    currentBoost < totalBoost &&
    currentProductIndex < boostedFeticheProducts.length
  ) {
    const currentProduct = boostedFeticheProducts[currentProductIndex];
    if (randomBoost < currentBoost + currentProduct.boost) {
      return currentProduct.id;
    }
    currentBoost += currentProduct.boost;
    currentProductIndex++;
  }

  const filteredScores = new Map(
    Array.from(productScores.entries())
      .filter(([id]) => feticheProducts.some((p) => p.id === id))
  );
  return getRandomIdWithMaxScore(filteredScores);
};

export const getSecondaryFeticheFragranceId = (
  mainFeticheFragranceId: ProfilerProductId,
  productScores: Map<ProfilerProductId, number>
): ProfilerProductId => {
  const feticheProducts = beautyProfilerProductRepository
    .getAllProducts()
    .filter((product) => product.type === "fetiche");
  const filteredScores = new Map(
    Array.from(productScores.entries())
      .filter(([id]) =>
        feticheProducts.some(
          (p) => p.id === id && p.id !== mainFeticheFragranceId
        )
      )
  );
  return getRandomIdWithMaxScore(filteredScores);
};

export const getTopLoubiworldFragranceId = (
  productScores: Map<ProfilerProductId, number>
): ProfilerProductId => {
  const loubiworldProducts = beautyProfilerProductRepository
    .getAllProducts()
    .filter((product) => product.type === "loubiworld");
  const filteredScores = new Map(
    Array.from(productScores.entries())
      .filter(([id]) => loubiworldProducts.some((p) => p.id === id))
  );
  return getRandomIdWithMaxScore(filteredScores);
};

export const getTopGlamlinerId = (
  productScores: Map<ProfilerProductId, number>
): ProfilerProductId => {
  const glamlinerProducts = beautyProfilerProductRepository
    .getAllProducts()
    .filter((product) => product.type === "glamliner");
  const filteredScores = new Map(
    Array.from(productScores.entries())
      .filter(([id]) => glamlinerProducts.some((p) => p.id === id))
  );
  return getRandomIdWithMaxScore(filteredScores);
};

export const getTopOtherProductIds = (
  productScores: Map<ProfilerProductId, number>,
  count: number
): ProfilerProductId[] => {
  const otherProducts = beautyProfilerProductRepository
    .getAllProducts()
    .filter((product) => product.type === "other-product");
  const filteredScores = new Map(
    Array.from(productScores.entries())
      .filter(([id]) => otherProducts.some((p) => p.id === id))
  );

  const result: ProfilerProductId[] = [];
  const scoresCopy = new Map(filteredScores);
  
  for (let i = 0; i < count && scoresCopy.size > 0; i++) {
    const selectedId = getRandomIdWithMaxScore(scoresCopy);
    result.push(selectedId);
    scoresCopy.delete(selectedId);
  }

  return result;
};